import React from 'react';

class ProjectPopupItem extends React.Component {
  constructor(props){
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.renderIcon = this.renderIcon.bind(this);
  }

  componentDidMount(){
    this.el.addEventListener('click', this.handleClick);
  }

  handleClick(e){
    const { onClick, feature } = this.props;
    const library = feature.getProperties();
    onClick(library);
  }

  renderIcon(){
    const { feature } = this.props;
    const type = feature.get('LIBRARY_TYPE');
    function getClass(type){
      switch(type){
        case 'dam_study': 
          return "ds ds-damicon icon-inline";
        case "levee_study":
          return "ds ds-levee icon-inline";
        case "cwms": 
          return "ds ds-cwms icon-inline";
        case "silver_jackets":
          return "ds ds-silver-jackets icon-inline";
        case "fema":
          return "ds ds-fema icon-inline";
        case "flood_fight":
          return "ds ds-flood-fight icon-inline";
        case "simdams":
          return "fv fv-simdams icon-inline";
        default:
          return "mdi mdi-map icon-inline";
      }
    }
    return <i className={getClass(type)} />
  }

  render(){
    const { feature } = this.props;
    const name = feature.get('NAME');
    return (
      <li ref={(el) => {this.el = el}}>
        <span style={{padding:3}}>
          { this.renderIcon() }
          { name }
        </span>
      </li>
    )
  }
}

export default ProjectPopupItem;